<template>
  <i
    v-if="isTimeshiftEnabled"
    v-accessibility-focus="togglePlay"
    :aria-label="$t('accessibility.player.togglePlay')"
    class="o-icon"
    :class="isPaused"
  ></i>
</template>
<script>
  import { PlayerStatus, TimeshiftMode } from '@/shared/components/player/enums';
  import { setPlayerStatus, state } from '@/shared/components/player/store';

  export default {
    name: 'UiPlayerTogglePlay',
    inject: ['$player'],
    computed: {
      isTimeshiftEnabled() {
        return state.timeshiftMode !== TimeshiftMode.DISABLED;
      },
      playerStatus() {
        return state.playerStatus;
      },
      isPaused() {
        return [PlayerStatus.PAUSE, PlayerStatus.STOPPED, PlayerStatus.ADVERTS_PAUSE, PlayerStatus.WAITING_INTERACTION].includes(this.playerStatus)
          ? 'o-icon--play'
          : 'o-icon--pause';
      },
      isWaitingInteraction() {
        return this.playerStatus === PlayerStatus.WAITING_INTERACTION;
      },
      isEmbedded() {
        return state.isEmbedded;
      },
    },
    methods: {
      togglePlay() {
        if (this.isWaitingInteraction && this.isEmbedded) {
          this.$player?.play();
          return;
        }

        if (!state.controlsEnabled && !state.advertControlsEnabled) {
          return;
        }

        if (this.playerStatus === PlayerStatus.PAUSE || this.playerStatus === PlayerStatus.WAITING_INTERACTION) {
          setPlayerStatus(PlayerStatus.PLAYING);
        } else if (this.playerStatus === PlayerStatus.PLAYING) {
          setPlayerStatus(PlayerStatus.PAUSE);
        } else if (this.playerStatus === PlayerStatus.ADVERTS_PAUSE) {
          setPlayerStatus(PlayerStatus.ADVERTS_PLAYING);
        } else {
          setPlayerStatus(PlayerStatus.ADVERTS_PAUSE);
        }
      },
    },
  };
</script>
